import { TrendingUp } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentEmployeesReportingTotalpoints } from '@/api/generated/company-management-user/company-management-user'
import { StatisticsCard } from '../components/StatisticsCard'

export function TopPointsCard() {
  const { t } = useTranslation('dashboard')
  const { data, isLoading, isError } = useGetApiCompaniesCurrentEmployeesReportingTotalpoints({ take: 1 })

  const top = data?.data?.[0]

  return (
    <StatisticsCard
      title={t('statistics.topPoints.title')}
      value={top?.totalPoints != null ? top.totalPoints.toLocaleString('de-DE') : '—'}
      sub={top ? [top.firstName, top.lastName].filter(Boolean).join(' ') : undefined}
      CustomIcon={TrendingUp}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
